var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextBlock"},[_c('StyledArticle',{staticClass:"text",attrs:{"theme-id":_vm.themeId}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }